import "./ReoMessage.css.ts.vanilla.mjs";
var e = "var(--p273__ReoMessage-c64a_fc3aa5673__1hhn7yc0)", _ = "p273__ReoMessage-c64a_fc3aa5673__1hhn7yc4", s = "p273__ReoMessage-c64a_fc3aa5673__1hhn7yc1";
export {
  e as animationFadeOutDelay,
  _ as reoMessageItem,
  s as reoMessageWarp
};
//# sourceMappingURL=ReoMessage.mjs.map
